import { createApi } from "@reduxjs/toolkit/query/react";

import { PhoneCodesResponse, CompetenciesResponse, FieldActivitiesResponse, HobbiesResponse } from "./types";
import { baseApiQuery } from "../../../shared/api";

export const presetDataApi = createApi({
  reducerPath: "presetDataApi",
  baseQuery: baseApiQuery,
  endpoints: (builder) => ({
    getPhoneCodes: builder.query<PhoneCodesResponse, void>({
      query: () => ({
        url: "/countries",
        method: "GET",
      }),
    }),
    getCompetencies: builder.query<CompetenciesResponse, void>({
      query: () => ({
        url: "/competencies",
        method: "GET",
      }),
    }),
    getFieldActivities: builder.query<FieldActivitiesResponse, void>({
      query: () => ({
        url: "/fieldactivities",
        method: "GET",
      }),
    }),
    getHobbies: builder.query<HobbiesResponse, void>({
      query: () => ({
        url: "/hobbies",
        method: "GET",
      }),
    }),
  }),
});

export const { useGetPhoneCodesQuery, useGetCompetenciesQuery, useGetFieldActivitiesQuery, useGetHobbiesQuery } =
  presetDataApi;
